/**
 * KAN-877 — "a suspended-screen reactivation is in progress" (the Confirming card -> celebration hand-off).
 * While true, the lazy-route boot splash trigger stays quiet: at the lift the app tree mounts for the first time
 * and its first chunk fallback would otherwise re-raise the CrewVex splash between the card and the celebration.
 * Module-level on purpose (read by App.js's Suspense fallback, set by SuspendedAccessGate); read at fallback mount.
 */
let active = false;
export const setReactivationInProgress = (on) => { active = Boolean(on); };
export const isReactivationInProgress = () => active;
